import type { QuestionProps } from '../eform.types'

export default function NameField({ question, value, onChange, error }: QuestionProps) {
  const strValue = Array.isArray(value) ? value[0] ?? '' : value
  const parts = strValue.split('|')
  const firstName = parts[0] || ''
  const lastName = parts[1] || ''

  function update(first: string, last: string) {
    onChange(`${first}|${last}`)
  }

  const missingFirst = question.isRequired && error && !firstName.trim()
  const missingLast = question.isRequired && error && !lastName.trim()

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-slate-500 mb-1">
            First Name {question.isRequired && <span className="text-red-500">*</span>}
          </label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => update(e.target.value, lastName)}
            placeholder="First name"
            className={`w-full rounded-lg border px-4 py-3 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary ${
              missingFirst ? 'border-red-300' : 'border-slate-200'
            }`}
          />
          {missingFirst && <p className="text-xs text-red-500 mt-1">First name is required</p>}
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-500 mb-1">
            Last Name {question.isRequired && <span className="text-red-500">*</span>}
          </label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => update(firstName, e.target.value)}
            placeholder="Last name"
            className={`w-full rounded-lg border px-4 py-3 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary ${
              missingLast ? 'border-red-300' : 'border-slate-200'
            }`}
          />
          {missingLast && <p className="text-xs text-red-500 mt-1">Last name is required</p>}
        </div>
      </div>
    </div>
  )
}
